import { render, staticRenderFns } from "./modal-components.vue?vue&type=template&id=51bae5a6&"
import script from "./modal-components.vue?vue&type=script&lang=js&"
export * from "./modal-components.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports